/**
 * @module:  状态栏模块
 * @author: Liang Huang
 * @date: 2019-09-23 15:13:05
 */
export default function navigatorMixin(hybrid) {
  var hybridJs = hybrid;
  hybridJs.extendModule('statusbar', [{
    // Use the default statusbar (dark text, for light backgrounds).
    namespace: 'styleDefault',
    os: ['ywk']
  }, {
    // Use the lightContent statusbar (light text, for dark backgrounds)
    namespace: 'styleLightContent',
    os: ['ywk']
  }, {
    // 根据hex string 设置状态栏背景色
    namespace: 'backgroundColorByHexString',
    os: ['ywk'],
    params: {
      color: '#F0F0F0'
    }
  }, {
    namespace: 'hide',
    os: ['ywk']
  }, {
    namespace: 'show',
    os: ['ywk']
  }]);
}